<template>
  <div class="graph_list">
    <div
      class="graph_list-item"
      v-for="(graph, index) in list"
      :key="index"
    >
      <CastomGraphic
          :received-data="graph"
          :graph-type="chartView"
          index-axis="x"
          :id="'graph_list-item-' + index"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>  
  </div>
</template>
<script>
export default {
  name: 'FilterGraphList',
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  props: {
    list: {
      type: Array,
      required: true
    },
    chartView: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
  .graph_list {
    &-item {
      margin-top: 50px;
    }
  }
</style>